import {PollRobotTemplate} from './PollRobotTemplate.js';

// type ResultOption struct {
// 	OptionId uint `json:"option_id"`
// 	Number uint `json:"number"`
// 	Option string `json:"option"`
// 	Count uint `json:"count"`
// }
export class ResultOptionModel {
	constructor(questionModel) {
		this.questionModel = questionModel;
		this.listeners = [];
	}
	addListener(l) {
		this.listeners.push(l);
	}
	removeListener(l) {
		this.listeners = this.listeners.filter(c=>l!=c);
	}
	setJs(js, answer_count) {
		this.js = js;
		this.option_id = js.option_id;
		this.option = js.option;
		this.count = js.count;

		this.listeners.map(l=>l.option_changed(this));
	}
	percentage() {
		return Math.round( 100 * parseInt(this.js.count) / this.questionModel.answerCount() );
	}
}

export class ResultOptionView {
	constructor(parent, orm) {
		this.orm = orm;
		[this.el, this.$] = PollRobotTemplate(`ResultOptionView`);
		this.$.option.innerText = orm.option;
		this.orm.addListener(this);
		parent.appendChild(this.el);
	}
	option_changed(o) {
		if (this.$.option.innerText!=o.option) {
			this.$.option.innerText = o.option;
		}
		// Set the bar 
		let perc = o.percentage();
		this.$.number.innerText = `${perc}%`;	//${o.count} ${perc}%`;
		this.$.bar.style.width = `${perc}%`;
	}

}
// type ResultQuestion struct {
// 	QuestionId uint `json:"question_id"`
// 	Number uint `json:"number"`
// 	Question string `json:"question"`
// 	Qtype QuestionType `json:"question_type"`
// 	Options []*ResultOption `json:"options"`
// }
export class ResultQuestionModel {
	constructor(resultModel) {
		this.resultModel = resultModel;
		this.listeners = [];
	}
	addListener(l) {
		this.listeners.push(l);
	}
	removeListener(l) {
		this.listeners = this.listeners.filter(c=>l!=c);
	}
	setJs(js) {
		this.js = js;
		this.id = js.question_id;
		this.number = js.number;
		this.question = js.question;
		this.qtype = js.question_type;
		if (this.options) {
			js.options.map( o=>{
				this.options[o.option_id].setJs(o);
			});
		} else {
			this.options = {};
			js.options.map( o=>{
				let model = new ResultOptionModel(this);
				this.options[o.option_id] = model;
				this.listeners.map(l => l.result_option_added(model));
				model.setJs(o);
			});
		}
		this.listeners.map(l => l.result_question_changed(this));
	}
	answerCount() {
		// at one point we calculated answer_count, but it seems much more logical to 
		// just accept it from the server
		return this.js.answer_count;
		// let cnt  =0;
		// if (this.js.answer_count) {
		// 	return this.js.answer_count;
		// }
		// if (this.js.totalcount){
		// 	return this.js.totalcount;
		// }
		// // if totalcount isn't set, we set it ourselves.
		// for (let oi in this.js.options){
		// 	let o = this.js.options[oi];
		// 	cnt += o.count;
		// }	
		// this.js.totalcount = cnt;
		// return cnt;
	}
}

export class ResultQuestionView {
	constructor(parent, questionModel) {
		this.questionModel = questionModel;
		[this.el, this.$] = PollRobotTemplate(`ResultQuestionView`);
		this.$.question.innerText = questionModel.question;
		questionModel.addListener(this);
		parent.appendChild(this.el);
	}
	result_option_added(o) {
		new ResultOptionView(this.$.options, o);
	}
	result_question_changed(qm) {
		console.log(`ResultQuestionView.result_question_changed qm = `, qm);
		this.$.question.innerText = qm.question;
	}
}
// type AskResult struct {
// 	AskID uint `json:"ask_id"`
// 	PollID uint `json:"poll_id"`
// 	Revision uint `json:"revision"`
// 	Title string `json:"title"`
// 	Questions []*ResultQuestion  `json:"questions"`
// 	AnswerCount uint `json:"answer_count"`
// }
export class ResultModel {
	constructor() {
		this.listeners = [];
	}
	addListener(l) {
		this.listeners.push(l);
	}
	removeListener(l) {
		this.listeners = this.listeners.filter(c=>l!=c);
	}
	answerCount() {
		if (!this.js) {
			return 0;
		}
		return this.js.answer_count;
	}
	setJs(js) {
		this.js = js;
		if (this.questions) {
			js.questions.map( q => this.questions[q.question_id].setJs(q) );
		} else {
			this.questions = {};
			js.questions.map( q=>{
				let qm = new ResultQuestionModel(this);
				this.questions[q.question_id] = qm;
				this.listeners.map(l => l.result_question_added(qm));
				qm.setJs(q);
			});
		}
		this.listeners.map(l=>l.result_changed(this));
	}
	matchesJs(js) {
		return this.js.ask_id == js.ask_id;
	}
	get title() {
		if (this.js) {
			return this.js.title;
		}
		return ``;
	}
}

export class ResultModelView {
	constructor(parent, model) {
		this.model = model;
		[this.el, this.$] = PollRobotTemplate(`ResultModelView`);
		this.$.title.innerText = model.title;
		model.addListener(this);
		parent.appendChild(this.el);
	}
	result_changed(model) {
		this.$.title.innerText = model.title;
		this.$.answerCount.innerText = model.answerCount();
	}
	result_question_added(questionModel) {
		new ResultQuestionView(this.$.questions, questionModel);
	}
}

export class AskResultViewer {
	constructor(el) {
		this.el = el;
		this.model = new ResultModel();
		this.view = new ResultModelView(this.el, this.model);
	}
	setJs(js) {
		this.model.setJs(js);
	}
	matchesJs(js) {
		return this.model.matchesJs(js);
	}
	static init() {
		document.querySelectorAll(`[data-instance="AskResultViewer"]`).forEach(el => new AskResultViewer(el));
		// for (let el of document.querySelectorAll(`[data-instance="AskResultViewer"]`)) {
		// 	new AskResultViewer(el);
		// }
	}
}